import pr000 from "./pr000"
import ho010 from "./ho010";
import ms151 from "./ms151";
import createms151 from "./createms151";
import ms151r from "./ms151r";
import ho006 from "./ho006";
import createho006 from "./createho006";
import ho003 from "./ho003";
import ms090 from "./ms090";
import createms090 from "./createms090"
import ho004 from "./ho004";
import pr002 from "./pr002";
import ho005 from "./ho005";
import createho005 from "./createho005";
import ho009 from "./ho009";

export default {
    pr000,
    ho010,
    ms151,
    createms151,
    ms151r,
    ho006,
    createho006,
    ho003,
    ms090,
    createms090,
    ho004,
    pr002,
    ho005,
    createho005,
    ho009
}